import {
  GUIAS_MOVIL,
  GUIAS_INTERNET,
  GUIAS_ESPECTACULARES,
  GUIAS_MEDIOS_IMPRESOS,
  GUIAS_VISITAS,
  GUIAS_REGISTROS,
  GUIAS_GEOCERCAS
} from 'constants/guiasTypes';
import { getFileDataUriSvg } from 'utils/file';

export const logoAssigner = (paramLogo) => {
  return getFileDataUriSvg(paramLogo);
};

export const nameAssigner = (paramLogo) => {
  switch (paramLogo) {
    case GUIAS_MOVIL.value:
      return GUIAS_MOVIL.label;
    case GUIAS_INTERNET.value:
      return GUIAS_INTERNET.label;
    case GUIAS_ESPECTACULARES.value:
      return GUIAS_ESPECTACULARES.label;
    case GUIAS_MEDIOS_IMPRESOS.value:
      return GUIAS_MEDIOS_IMPRESOS.label;
    case GUIAS_VISITAS.value:
      return GUIAS_VISITAS.label;
    case GUIAS_REGISTROS.value:
      return GUIAS_REGISTROS.label;
    case GUIAS_GEOCERCAS.value:
      return GUIAS_GEOCERCAS.label;
    default:
      return null;
  }
};
